<div class="pages-skeleton-component">
  <div class="animate-pulse bg-white h-96 w-full rounded-xl my-3"></div>
</div>
